import { Typography, Box, BoxProps } from '@mui/material';
import SunnysideGrid from '../../../components_sunnyside/grid';
import { styled } from '@mui/material/styles';

import Image from '../../../components_sunnyside/image';
import ReviewsHero from '../../../../public/img/sunnyside/reviews_banner.png';
import { colors } from '../../../styles/_colors';
import SunnysideButton from '../../../components_sunnyside/button';
import useWindowSize from '../../../utils/useWindowSize';
import { PrismicReviewsPageData } from '../../../utils/prismic/types/pages/reviews.type';

interface ReviewsBannerProps {
    reviewData: PrismicReviewsPageData
}


export default function ReviewsBanner(props: ReviewsBannerProps): JSX.Element {
    const { reviewData } = props;
    const { width } = useWindowSize();
    const ContentBox = styled(Box)<BoxProps>(({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('lg')]: {
            width: '100%',
            paddingTop: '3rem',
            alignItems: 'center',
            justifyContent: 'center',
        },
        [theme.breakpoints.up('lg')]: {
            width: '55%',
            paddingRight: '3rem'
        },
    }));
    const ButtonBox = styled(Box)<BoxProps>(({ theme }) => ({
        display: 'flex',
        width: '100%',
        [theme.breakpoints.down('lg')]: {
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        },
        [theme.breakpoints.up('lg')]: {
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            flexDirection: 'row'
        },
    }));
    const ImageBox = styled(Box)<BoxProps>(({ theme }) => ({
        display: 'flex',
        [theme.breakpoints.down('lg')]: {
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
        },
        [theme.breakpoints.up('lg')]: {
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            width: '45%',
        },
    }));
    return (
        <SunnysideGrid maxwidthgrid
            display='flex'
            justifyContent='center'
            alignItems='center'
            flexDirection={width > 1200 ? 'row' : 'column-reverse'}>
            <ContentBox>
                <Typography variant='h1'
                    textAlign={width > 1200 ? 'left' : 'center'}>
                    {reviewData.data.hero_heading}
                </Typography>
                <Typography variant='body2' 
                    color={colors.pine}
                    padding='3rem 0rem'
                    textAlign={width > 1200 ? 'left' : 'center'}>
                    {reviewData.data.hero_paragraph}
                </Typography>
                <ButtonBox>
                    <SunnysideButton 
                        width='18.6875rem' 
                        margin={width > 1200 ? '0rem 1rem 0rem 0rem' : '1rem 0rem'}
                        url='https://www.trustpilot.com/evaluate/sunnyside.co'
                        external
                        padding='0.5rem 0rem'>
                        Write A Review
                    </SunnysideButton>
                    <SunnysideButton width='18.6875rem' href='mailto:hello@sunnyside.co'>
                        Contact Us
                    </SunnysideButton>
                </ButtonBox>
            </ContentBox>
            <ImageBox>
                <Image src={ReviewsHero}
                    alt='review page banner' 
                    width={547}
                    height={514}
                    priority
                    objectFit='cover'
                    objectPosition='center bottom'/>
            </ImageBox>
        </SunnysideGrid>
    );
}